import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../Context/useAuth";
import { paths } from "../Constant/paths";
import { USER_TYPE } from "Constant/constants";
import { saveRedirectAfterLogin } from "Utils";

export const PublicRoutes = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    return (
      <Navigate
        to={
          user.type === USER_TYPE.Applicant
            ? paths.applicant.dashboard
            : paths.admin.dashboard
        }
      />
    );
  }

  return children ? React.cloneElement(children, {}, <Outlet />) : <Outlet />;
};

export function PrivateRoutes({ children }) {
  const { isAuthenticated, isOnboardingCompleted } = useAuth();
  const location = useLocation();

  const isOnboardingPage = location.pathname === paths.common.onboarding;
  if (!isAuthenticated) {
    saveRedirectAfterLogin(`${location.pathname}${location.search}`);
    return <Navigate to={paths.root} />;
  }

  if (!isOnboardingCompleted && !isOnboardingPage) {
    return <Navigate to={paths.common.onboarding} />;
  }

  return children ? React.cloneElement(children, {}, <Outlet />) : <Outlet />;
}
